import React from 'react';
import * as Backend from "../../backend.js";
import * as util from "../../other/util.js";
import ItemListView from "../item-list-view.js";

// Shows all items of the player
class InventoryView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        Backend.getInventory((res) => {
            this.setState({ items: res.items });
        }
        );
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let items = this.state.items;
        return (
            <div className="fade-in" key={Math.random()}>
                <h1>Inventory</h1>
                <ItemListView items={items} />
                <br />
                <util.JsonDebug obj={items} />
            </div>
        );
    }
}

export default util.withNavigation(InventoryView);